// ── ☆ 킵 해제 모달 ──────────────────────────────────────────────────────────
// - 다시 방문 배정: 방문일자 + 마케터 선택 후 저장
// - 미팅 종료로 처리(UI 문구): feedback='방문취소', is_keep=false (저장값은 방문취소 유지)
// - keepReleaseActions(2026-11-02): 이 사람이 이 콜에 쓸 수 있는 버튼 { memo, close, reassign } — 못 쓰는 버튼은 회색으로 막고 한 줄 안내.
//   null(못 물어봄·통합 메뉴) = 전부 켬(예전 그대로). 판정은 서버 GET /api/tm/calls/:id/keep-actions(저장과 같은 규칙).

import React from 'react';
import Modal from '../../../components/Modal';
import { miniBtn, submitBtn } from './formStyles';
import { keepReleaseLabel, keepReleaseFieldStyle, keepReleaseCancelBtnStyle } from './listChipStyles';

export function KeepReleaseModal({
  keepReleaseOpen, setKeepReleaseOpen,
  keepReleaseDate, setKeepReleaseDate,
  keepReleaseSales, setKeepReleaseSales,
  keepReleaseMemo, setKeepReleaseMemo,
  keepReleaseSaving, salesPersonNames, keepReleaseActions = null,
  onKeepMemoSave, onKeepReleaseAssign, onKeepReleaseCancelVisit,
}) {
  const can = (k) => !keepReleaseActions || keepReleaseActions[k] !== false;
  const blocked = (ok) => (ok ? null : { opacity: 0.45, cursor: 'not-allowed' });
  const hint = { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5 };
  return (
    <Modal
      open={keepReleaseOpen}
      title="☆ 킵 해제"
      icon="⭐"
      onClose={() => setKeepReleaseOpen(false)}
      footer={<button style={miniBtn} onClick={() => setKeepReleaseOpen(false)}>닫기</button>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, minWidth: 260 }}>
        {!can('close') && (
          <div style={hint}>남이 적은 킵 콜은 '킵 미팅종료 처리' 열쇠가 있어야 메모 저장·미팅 종료를 할 수 있어요.</div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={keepReleaseLabel}>킵 메모</div>
          <textarea
            style={{
              ...keepReleaseFieldStyle,
              height: 92,
              resize: 'vertical',
              lineHeight: 1.5,
              whiteSpace: 'pre-wrap',
            }}
            value={keepReleaseMemo || ''}
            readOnly={!can('memo')}
            placeholder="킵으로 남긴 이유나 확인할 내용을 적어두세요."
            onChange={(e) => setKeepReleaseMemo(e.target.value)}
          />
          <button
            type="button"
            style={{ ...miniBtn, alignSelf: 'flex-end', minWidth: 86, height: 30, ...blocked(can('memo')) }}
            disabled={keepReleaseSaving || !can('memo')}
            onClick={onKeepMemoSave}
          >
            메모 저장
          </button>
        </div>

        <div style={{ borderTop: '1px solid var(--border)' }} />

        {/* Section 1: 다시 방문 배정 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {!can('reassign') && <div style={hint}>다시 방문 배정은 본인 콜이거나 일일콜 관리 권한이 있어야 해요.</div>}
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            {/* 방문일자 입력 */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={keepReleaseLabel}>방문일자</div>
              <input type="date" style={keepReleaseFieldStyle} disabled={!can('reassign')}
                value={keepReleaseDate} onChange={(e) => setKeepReleaseDate(e.target.value)} />
            </div>
            {/* 마케터 선택 또는 입력 */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1, minWidth: 100 }}>
              <div style={keepReleaseLabel}>마케터</div>
              {salesPersonNames.length > 0 ? (
                <select style={keepReleaseFieldStyle} disabled={!can('reassign')}
                  value={keepReleaseSales} onChange={(e) => setKeepReleaseSales(e.target.value)}>
                  {salesPersonNames.map((n) => <option key={n} value={n}>{n}</option>)}
                </select>
              ) : (
                <input style={keepReleaseFieldStyle} type="text" value={keepReleaseSales} disabled={!can('reassign')}
                  placeholder="마케터명" onChange={(e) => setKeepReleaseSales(e.target.value)} />
              )}
            </div>
          </div>
          <button
            style={{ ...submitBtn, width: '100%', height: 34, boxSizing: 'border-box', fontSize: 13, ...blocked(can('reassign')) }}
            disabled={keepReleaseSaving || !keepReleaseDate.trim() || !can('reassign')}
            onClick={onKeepReleaseAssign}
          >
            다시 방문 배정하기
          </button>
        </div>

        <div style={{ borderTop: '1px solid var(--border)' }} />

        {/* Section 2: 미팅 종료 처리 (저장값은 feedback='방문취소' 유지) */}
        <button style={{ ...keepReleaseCancelBtnStyle, ...blocked(can('close')) }}
          disabled={keepReleaseSaving || !can('close')} onClick={onKeepReleaseCancelVisit}>
          미팅 종료로 처리하기
        </button>
      </div>
    </Modal>
  );
}
